import { render, staticRenderFns } from "./BubbleMap.vue?vue&type=template&id=ddaf8850&"
import script from "./BubbleMap.vue?vue&type=script&lang=js&"
export * from "./BubbleMap.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BubbleMap.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports